import React from "react";
import { useTranslation } from "react-i18next";
import { useToggleCompareItem } from "../../hooks/useToggleCompareItem";
import Icon from "../../../../../common/components/Icon/Icon";

interface CompareToggleButtonProps {
  productId: number;
  className?: string;
}

const CompareToggleButton: React.FC<CompareToggleButtonProps> = ({
  productId,
  className,
}) => {
  const { t } = useTranslation();
  const { handleToggle, isInCompare, isLoading } =
    useToggleCompareItem(productId);

  const title = isInCompare
    ? t("compareToggleButton.removeFromCompareTitle", "Remove from Compare")
    : t("compareToggleButton.addToCompareTitle", "Add to Compare");

  return (
    <button
      className={`compare-toggle-button ${className || ""} ${
        isInCompare ? "is-active" : ""
      }`}
      aria-label={title}
      title={title}
      onClick={handleToggle}
      disabled={isLoading}
    >
      {/* We use the same icon for both states, but change color via CSS based on is-active */}
      <Icon iconName="arrows-right-left" className="icon--stroke-thick" />
    </button>
  );
};

export default CompareToggleButton;
